/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useState} from 'react'
import {Box} from '@mui/material'
import DataTable, {PaginationState} from 'src/components-new/data/DataTable'
import Filters, {FilterItem, FilterResult} from 'src/components-new/data/Filters'
import {useToast} from 'src/components-new/feedback/ToastProvider'
import {STATUS} from 'src/constants/constants'
import {useAppSelector} from 'src/hooks'
import apiClient from 'src/services/apiClient'
import {buildLinksColumns, filterLinksFiltersByColumns, LinkRecord} from './columns'

const LINKS_FILTER_CONFIG: FilterItem[] = [
  {id: 'name', label: 'Titolo', type: 'string'},
  {id: 'rangeDates', label: 'Data', type: 'rangePicker'},
]

export default function UsefulLinksTab(): JSX.Element {
  const infoMaterialsConfig = useAppSelector(
    (state) => state.pspConfigReducer.data.infoMaterialsConfigurations
  )
  const linksColumnOptions = infoMaterialsConfig?.links?.columnOptions

  const [data, setData] = useState<LinkRecord[]>([])
  const [count, setCount] = useState(0)
  const [loadStatus, setLoadStatus] = useState<string>(STATUS.PENDING)
  const [pagination, setPagination] = useState<PaginationState>({
    page: 0,
    rowsPerPage: 10,
    order: '-createdAt',
  })
  const [activeFilters, setActiveFilters] = useState<FilterResult[]>([])

  const toast = useToast()

  const fetchData = useCallback(async () => {
    setLoadStatus(STATUS.PENDING)
    const fetched: any[] = (await apiClient.getLinks(activeFilters, setLoadStatus, pagination)) ?? []
    setData(fetched)
    const cnt = (await apiClient.getLinksCount(activeFilters, () => {})) ?? 0
    setCount(Number(cnt))
  }, [activeFilters, pagination])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  useEffect(() => {
    if (loadStatus === STATUS.REJECTED) {
      toast.error('Errore nel recuperare i link.')
    }
  }, [loadStatus])

  const handleFiltersSubmit = (values: FilterResult[]) => {
    setActiveFilters(values)
    setPagination((p) => ({...p, page: 0}))
  }

  const columns = buildLinksColumns({columnOptions: linksColumnOptions})
  const visibleFilters = filterLinksFiltersByColumns(LINKS_FILTER_CONFIG, columns)
  // Only show the mobile card header when "name" survived the PSP's columnOptions
  // (or no config was set at all) — otherwise a disabled column would still show up there.
  const hasNameColumn = columns.some((col) => col.key === 'name')

  return (
    <Box>
      {visibleFilters.length > 0 && (
        <Box sx={{display: 'flex', justifyContent: 'flex-end', mb: 2}}>
          <Filters config={visibleFilters} onSubmit={handleFiltersSubmit} />
        </Box>
      )}

      <DataTable<LinkRecord>
        columns={columns}
        rows={data}
        keyField="_id"
        loading={loadStatus === STATUS.PENDING}
        emptyMessage="Nessun link trovato"
        totalElements={count}
        pagination={pagination}
        onPaginationChange={setPagination}
        onRowClick={(row) => row.url && window.open(row.url, '_blank', 'noopener')}
        mobileCardTitle={hasNameColumn ? (row) => row.name ?? '—' : undefined}
      />
    </Box>
  )
}
